/* eslint-disable no-unused-vars */
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { CustomCol, FormLabels, CustomInputDecimal } from 'src/components'

interface BrokerageSalePriceFieldProps {
  purchaseCurrency: string
  setPurchaseCurrency: (value: string) => void
}

const BrokerageSalePriceField: React.FC<BrokerageSalePriceFieldProps> = ({ purchaseCurrency, setPurchaseCurrency }) => {
  const { t } = useTranslation()

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('admin.Brokerage.PriceStock')}
        subtitle={t('general.RequiredField')}
      />
    </CustomCol>
    <CustomCol>
      <CustomInputDecimal
        name={'salePrice'}
        placeholder={t('admin.Brokerage.SalePricePlaceHolder')}
        defautlCurrencyValue={purchaseCurrency}
        handleCurrencyChange={(value: string) => setPurchaseCurrency(value)}
        required
        hasCurrency
      />
    </CustomCol>
  </Row>
}

export default BrokerageSalePriceField
